export default __webpack_public_path__ + "static/media/icon-add-arrow.0c853063.svg";